var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    { attrs: { id: _vm.id, options: _vm.options, title: "Kickstart" } },
    [
      _c("p", { staticClass: "text-gray-700 leading-relaxed mb-3" }, [
        _vm._v(
          " Ok, if you really don't know where to start I can help you. I understand how intimidating a blank canvas can be! "
        )
      ]),
      _c("p", { staticClass: "text-gray-700 leading-relaxed mb-4" }, [
        _vm._v(
          " Using the button below, I'll add the top 100 rated movies from IMDb to your collection. But after this, you're not getting any more suggestions from me! Ask your friends for recommendations, and every time that you come accross something you like, come back to save it. Never forget a movie again! "
        )
      ]),
      _c(
        "BaseButton",
        {
          staticClass:
            "\n            border border-primary-500 text-sm text-primary-700 justify-center\n            hover:bg-black-overlay\n        ",
          on: { click: _vm.importImdbTop100RatedMovies }
        },
        [_vm._v(" Add the top 100 rated movies from IMDb to my collection ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }